export const validateEmail = (email: string) => {
  const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,63}$/;
  return emailRegex.test(email);
};

export const validatePassword = (password: string) => {
  //at least 1 special character, at least 1 number, at least 1 upper case letter, at least 1 lower case letter
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/;
  return regex.test(password);
};
